import { render, staticRenderFns } from "./IconSvgClip.vue?vue&type=template&id=7093c692&scoped=true&"
import script from "./IconSvgClip.vue?vue&type=script&lang=js&"
export * from "./IconSvgClip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7093c692",
  null
  
)

export default component.exports